import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select-legacy';
import { useTranslation } from 'react-i18next';

class CheckboxOption extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    isDisabled: PropTypes.bool,
    isFocused: PropTypes.bool,
    isSelected: PropTypes.bool,
    onFocus: PropTypes.func,
    onSelect: PropTypes.func,
    option: PropTypes.object.isRequired,
  };

  handleMouseDown = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.props.onSelect(this.props.option, e);
  }

  handleMouseEnter = (e) => {
    this.props.onFocus(this.props.option, e);
  }

  handleMouseMove = (e) => {
    if (this.props.isFocused) return;
    this.props.onFocus(this.props.option, e);
  }

  render() {
    const { children, className, isSelected, option } = this.props;
    return (
      <div className={className} onMouseDown={this.handleMouseDown} onMouseEnter={this.handleMouseEnter} onMouseMove={this.handleMouseMove} title={option.title}>
        { isSelected && <i className='sp-icon-checkmark'></i> }
        <span className={isSelected ? 'u-margin-left--tiny' : 'u-margin-left--base' }>{ children }</span>
      </div>
    );
  }
}

const valueRender = () => ''

const SelectCheckbox = ({ value, options, onChange, disabled }) => {
  const { t, i18n } = useTranslation();
  const wrapRef = useRef(null);
  const label = t('accountPlayers.filters.columnVisibility');

  useEffect(() => {
    if (wrapRef.current) {
      const el = wrapRef.current.querySelector('.Select-multi-value-wrapper');
      if (el) el.setAttribute('data-label', label);
    }
  }, [label]);

  return (
    <div ref={wrapRef} style={{ display: 'contents' }}>
      <Select
        key={i18n.language}
        autosize={true}
        closeOnSelect={false}
        multi={true}
        removeSelected={false}
        className='o-select o-select--checkbox'
        clearable={false}
        placeholder={label}
        searchable={false}
        value={value}
        onChange={onChange}
        options={options}
        optionClassName='o-select__option--checkbox'
        optionComponent={CheckboxOption}
        simpleValue={true}
        valueRenderer={valueRender}
        disabled={disabled}
      />
    </div>
  );
}

SelectCheckbox.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string),
  options: PropTypes.arrayOf(PropTypes.object),
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
}

export default SelectCheckbox;
